
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyCVdI7qx98SoeHDi4ZJZ_45k8Oq0kUeitB8pRBrDDxAl4Meta } from "/Users/omar/projects/mvp/mvp-website-new/pages/index.vue?macro=true";
import { default as thankyouU8qaabinJutbdSZIBcRctTVK_vY_orTGMPhxfkf9dSYMeta } from "/Users/omar/projects/mvp/mvp-website-new/pages/thankyou.vue?macro=true";
import { default as no_45interest_45TB7rdkXxsN9pW8oQolT9zk0NoUqMA7zJW7GXH1h0XYMeta } from "/Users/omar/projects/mvp/mvp-website-new/pages/no-interest.vue?macro=true";
import { default as privacy_45policyZfLnxvJiI3ZLGaqrKoZ8_45dsYvRheurOaVfPh_iZ7QLQMeta } from "/Users/omar/projects/mvp/mvp-website-new/pages/privacy-policy.vue?macro=true";
import { default as thankyou_45for_45respondingCfiKmHC7opYY62hIvPHXVRs_aynF_1ciKbQIRVC_45fxwMeta } from "/Users/omar/projects/mvp/mvp-website-new/pages/thankyou-for-responding.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Users/omar/projects/mvp/mvp-website-new/pages/index.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/Users/omar/projects/mvp/mvp-website-new/pages/thankyou.vue")
  },
  {
    name: "no-interest",
    path: "/no-interest",
    component: () => import("/Users/omar/projects/mvp/mvp-website-new/pages/no-interest.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/Users/omar/projects/mvp/mvp-website-new/pages/privacy-policy.vue")
  },
  {
    name: "thankyou-for-responding",
    path: "/thankyou-for-responding",
    component: () => import("/Users/omar/projects/mvp/mvp-website-new/pages/thankyou-for-responding.vue")
  }
]